// src/components/RecordCard.js
import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const RecordCard = ({ record, onDelete, isDeleting }) => {
  // Format date for better readability
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span>Record ID: {record.id}</span>
        <Button 
          variant="danger" 
          size="sm" 
          onClick={() => onDelete(record.id)}
          disabled={isDeleting}
        >
          {isDeleting ? (
            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          ) : (
            <FontAwesomeIcon icon={faTrash} />
          )}
          {' '}Delete
        </Button>
      </Card.Header>
      
      <Card.Body>
        <Card.Title>{record.name || 'No Name'}</Card.Title>
        <Card.Text as="div">
          <p>
            <strong>Email:</strong> {record.email}
          </p>
          <p>
            <strong>Created:</strong> {formatDate(record.created_at)}
          </p>
          <p>
            <strong>Updated:</strong> {formatDate(record.updated_at)}
          </p>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default RecordCard;